<template>
    <div class="p-grid data-table data-table-list">
        <div class="p-col-12">
            <div class="card card-w-title">
                <!-- <h1>List of purchases - {{$route.params.type}}</h1> -->
                <DataTable :value="commissions" class="p-datatable-responsive" :paginator="true" :rows="10" :filters="filters" :autoLayout="true">
                    <template #header>
                        <h2>List of commissions</h2>
                    </template>
                    <Column field="time" header="Time:" :sortable="true" filterMatchMode="custom" :filterFunction="filterDate">
                        <template #filter>
                            <Calendar v-model="filters['time']" dateFormat="yy-mm-dd" class="p-column-filter" placeholder="Date"/>
                        </template>
                        <template #body="slotProps">
                            <!-- <span class="p-column-title">Time</span> -->
                            <span>{{ formatDate(slotProps.data.time) }}</span>
                        </template>
                    </Column>
                    <Column field="type" header="Type" :sortable="true" filterMatchMode="contains">
                        <template #body="slotProps">
                            <!-- <span class="p-column-title">Type</span> -->
                            <span>{{ slotProps.data.type }}</span>
                        </template>
                        <template #filter>
                            <InputText type="text" v-model="filters['type']" class="p-column-filter" placeholder="Contains" />
                        </template>
                    </Column>
                    <Column field="amount" header="Amount" :sortable="true" filterMatchMode="contains">
                        <template #body="slotProps">
                            <!-- <span class="p-column-title">Amount</span> -->
                            <span>{{ formatCurrency(slotProps.data.amount) }}</span>
                        </template>
                        <template #filter>
                            <InputText type="text" v-model="filters['amount']" class="p-column-filter" placeholder="Contains" />
                        </template>
                    </Column>
                  
                    <Column field="origin_name" header="Origin" :sortable="true" filterMatchMode="contains">
                        <template #body="slotProps">
                            <!-- <span class="p-column-title">Origin</span> -->
                            <span>{{ slotProps.data.origin_name }}</span>
                        </template>
                        <template #filter>
                            <InputText type="text" v-model="filters['origin_name']" class="p-column-filter" placeholder="Contains" />
                        </template>
                    </Column>

                    <!-- <Column v-for="col of columns" :field="col.field" :header="col.header" :key="col.field">
        <template #editor="slotProps">
            <InputText :value="slotProps.data[slotProps.column.field]" />
        </template>
    </Column> -->
                </DataTable>
            </div>
        </div>

       
        
    </div>
</template>

<script>

import CommissionService from '../../service/CommissionService';

export default {
    data() {
        return {
            commissions: null,
            filters: {},
            activeRow: {},
            display: false,
            title: '',
            message: 'Test message'
            // columns: null
        }
    },
    created() {
        this.commissionService = new CommissionService();
        
    },
    async mounted() {
        this.commissionService.listCommissionsSelf(100, this.$store.state.currentUser.token).then(data => this.commissions = data);
        //console.log(this.commissions);
    },
    methods: {
        filterDate(value, filter) {
            if (filter === undefined || filter === null || (typeof filter === 'string' && filter.trim() === '')) {
                return true;
            }

            if (value === undefined || value === null) {
                return false;
            }
            return this.getDate(value) === this.getDate(filter)
        },
     
        formatDate(date) {
            var d = new Date(date),
                month = "" + (d.getMonth() + 1),
                day = "" + d.getDate(),
                year = d.getFullYear(),
                hours = "" + d.getHours(),
                mins = "" + d.getMinutes();

            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;
            if (hours.length < 2) hours = "0" + hours;
            if (mins.length < 2) mins = "0" + mins;

            return [year, month, day].join("-") + " " + hours + ":" + mins;
        },

        getDate(timestamp) {
            var d = new Date(timestamp),
                month = "" + (d.getMonth() + 1),
                day = "" + d.getDate(),
                year = d.getFullYear(),
                hours = "" + d.getHours(),
                mins = "" + d.getMinutes();

            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;
            if (hours.length < 2) hours = "0" + hours;
            if (mins.length < 2) mins = "0" + mins;

            return [year, month, day].join("-");
        },

        formatCurrency(value) {
            return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(value);
        },
    }
}

</script>

<style scoped>
</style>